import { Colors } from '@oy/uicore';
import { Spacer, Text } from '@oy/uidesktop';
import { useSelector } from 'react-redux';
import { useTranslate, useUserRole } from 'src/hooks';
import { B2xUserAccountType } from 'src/redux/reducers/mainReducer';
import { RootState } from 'src/redux/reducers/rootReducer';
import { MAIL_TEMPLATE } from '../../constants/';
import styles from '../Sidebar.module.css';

const ApiRequestWidget = () => {
  const { getTranslation } = useTranslate();
  const { isAdmin } = useUserRole();
  const { paymentInfo, loadingPaymentInfo } = useSelector(
    (state: RootState) => state.main,
  );

  const handleContactBusinessTeam = () => {
    const href =
      `mailto:${MAIL_TEMPLATE.RECIPIENT}?subject=${paymentInfo?.username} - ` +
      `${MAIL_TEMPLATE.SUBJECT}&body=${MAIL_TEMPLATE.BODY}`;
    window.open(href);
  };

  const renderRequestApiWidget = () => {
    if (
      !loadingPaymentInfo &&
      !paymentInfo?.hasProdApiKey &&
      isAdmin &&
      paymentInfo?.accountType === B2xUserAccountType.APPROVED
    ) {
      return (
        <Spacer top={Spacer.Size.XL} bottom={Spacer.Size.M}>
          <section className={styles.apiKeyStaging}>
            <Text textStyle={Text.Style.BodySmSemibold} color={Colors.BLACK60}>
              {getTranslation('requestApiWidget_title')}
            </Text>
            <Spacer top={Spacer.Size.XS} className={styles.apiKeyStagingBottom}>
              <Text
                textStyle={Text.Style.BodyLgRegular}
                onClick={handleContactBusinessTeam}
                className={styles.textContact}
              >
                {getTranslation('requestApiWidget_contactBusinessTeam')}
              </Text>
            </Spacer>
          </section>
        </Spacer>
      );
    }
    return null;
  };

  return renderRequestApiWidget();
};

export default ApiRequestWidget;
